export default __webpack_public_path__ + "static/media/f.f66e34cf.svg";